import { Suspense } from 'react';
import ErrorBoundary from 'Components/ErrorBoundary';
import { Router } from 'Routes';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { ActivityGuard } from 'Components/ActivityGuard';
import { Loader } from 'Components';

interface IAPP {
  msalInstance: PublicClientApplication;
}

function App({ msalInstance }: IAPP) {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <ActivityGuard>
            <Suspense fallback={<Loader />}>
              <Router />
            </Suspense>
          </ActivityGuard>
        </MsalProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
